import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const server_folder = localStorage.getItem("server_folder");
  const membership_hide_show = localStorage.getItem("membership_hide_show");
  const membership_status = localStorage.getItem("membership_status");
  const company_header_logo = localStorage.getItem("company_header_logo");

  // MAIN PAGES (NO BACK BUTTON)
  const mainPages = ["/", "/search", "/home", "/profile", "/more"];

  // PAGES THAT SHOULD GO TO HOME WHEN BACK IS CLICKED
  const goHomePages = [
    "/customers",
    "/vehicles", 
    "/history",
    "/serviceReminderList",
    "/vendors",
    "/purchases",
    "/transaction",
  ];

  // PARENT-CHILD PAGE RELATIONSHIPS
  // Child pages should go back to their parent list pages
  const parentPages = {
    // Edit pages
    "/edit-customer": "/customers",
    "/edit-vehicle": "/vehicles",
    "/edit-insurance": "/insurance",
    "/edit-vendor": "/vendors",
    "/edit-purchase": "/purchases",
    "/edit-transaction": "/transaction",
    "/edit-service-reminder": "/serviceReminderList",
    "/edit-vendor-transaction": "/vendors",
    
    // Add pages
    "/add-insurance": "/insurance",
    "/add-vendor": "/vendors",
    "/add-purchase": "/purchases",
    "/add-transaction": "/transaction",
    "/add-service-reminder": "/serviceReminderList",
    "/add-vendor-transaction": "/vendors",
    
    // Other pages
    "/terms": "/more",
    "/privacy": "/more",
    "/about-us": "/more",
    "/garageterms": "/more"
  };

  const getPageTitle = (pathname) => {
    if (pathname.startsWith("/home/")) return "Welcome Back";
    if (pathname.startsWith("/edit-insurance/")) return "Edit Insurance Policy";
    if (pathname.startsWith("/edit-vehicle/")) return "Edit Vehicle";
    if (pathname.startsWith("/edit-purchase/")) return "Edit Purchase";
    if (pathname.startsWith("/job-card-details/")) return "Job Card Details";

    const pageTitles = {
      "/": "Welcome Back",
      "/vendor-transactions": "Transaction List",
      "/transaction-dashboard": "Dashboard",
      "/insurance": "Insurance List",
      "/purchases": "Purchase List",
      "/transaction": "Transaction List",
      "/vendors": "Vendor List",
      "/serviceReminderList": "Reminder List",
      "/PackageList": "Package List",
      "/membership": "Membership List",
      "/search": "Search",
      "/suggestions": "Suggestion",
      "/garageterms": "Garage T&C",
      "/home": "Welcome Back",
      "/Addjobcart": "Add job card",
      "/edit-vehicle": "Edit Vehicle",
      "/edit-customer": "Edit Customer",
      "/add-customer-vehicle": "Add Customer & Vehicle",
      "/customers": "Customer List",
      "/vehicles": "Vehicles List",
      "/profile": "My Profile",
      "/history": "Vehicle History",
      "/more": "More Options",
      "/terms": "Terms & Conditions",
      "/privacy": "Privacy Policy",
      "/about-us": "About Our Company",
      "/add-insurance": "Add Insurance Policy",
      "/edit-insurance": "Edit Insurance Policy",
      "/add-vendor": "Add Vendor",
      "/edit-vendor": "Edit Vendor",
      "/add-purchase": "Add Purchase",
      "/edit-purchase": "Edit Purchase",
      "/add-transaction": "Add Transaction",
      "/edit-transaction": "Edit Transaction",
      "/add-service-reminder": "Add Service Reminder",
      "/edit-service-reminder": "Edit Service Reminder",
      "/add-vendor-transaction": "Add Vendor Transaction",
      "/edit-vendor-transaction": "Edit Vendor Transaction",
    };

    return pageTitles[pathname] || "404 Not Found";
  };

  const pageTitle = getPageTitle(location.pathname);

  // SMART BACK NAVIGATION
  const goBack = () => {
    const currentPath = location.pathname;
    
    // Check for parent-child relationships first
    for (const [childPage, parentPage] of Object.entries(parentPages)) {
      if (currentPath === childPage || currentPath.startsWith(childPage + '/')) {
        navigate(parentPage);
        return;
      }
    }
    
    // Check if current page should go to home
    const shouldGoHome = goHomePages.some(page => 
      currentPath === page || currentPath.startsWith(page + '/')
    );
    
    if (shouldGoHome) {
      navigate("/more");
    } else {
      navigate(-1);
    }
  };

  const isMainPage = mainPages.includes(location.pathname);
  const isHomePage = location.pathname === "/home" || location.pathname === "/";

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-header">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        {/* LEFT SIDE */}
        {isMainPage ? (
          isHomePage ? (
            <img
              src={company_header_logo}
              alt="Company Logo"
              className="company-logo"
              style={{
                height: "42px",
                objectFit: "contain",
                cursor: "pointer",
              }}
              onClick={() => navigate("/home")}
            />
          ) : (
            <div className="header-title" style={{ fontSize: "20px", color: "white" }}>
              {pageTitle}
            </div>
          )
        ) : (
          <button className="btn text-white" onClick={goBack}>
            <i className="fas fa-arrow-left" style={{ fontSize: "22px" }}></i>
          </button>
        )}

        {/* CENTER TITLE */}
        {!isMainPage && (
          <div
            className="header-title text-center flex-grow-1"
            style={{
              width: "70%",
              fontSize: "20px",
              color: "white",
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
            }}
          >
            {pageTitle}
          </div>
        )}

        {/* RIGHT SIDE */}
        <div className="d-flex align-items-center gap-3">
          {isHomePage ? (
            membership_hide_show == 1 && (
              <img
                src={membership_status === 'active' ? `${server_folder}/img/status1.png` : `${server_folder}/img/status0.png`}
                alt="Membership Status"
                style={{
                  height: "42px",
                  objectFit: "contain",
                  cursor: "pointer",
                }}
                onClick={() => navigate("/PackageList")}
              />
            )
          ) : isMainPage && (
            <button type="button" id="sidebarrightbutton" className="btn" style={{ padding: 0, margin: 0 }}>
              <img
                src={company_header_logo}
                alt="Company Logo"
                style={{
                  height: "42px",
                  objectFit: "contain",
                  borderRadius: "4px",
                }}
              />
            </button>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Header;